<app-manage-template [title]="'Edit Member Network'" [FIELDS]="fields" [COLUMNFIELDS]="columns"
[userData]="(userDatas | async)" [parentData]="businessNetworkDetails" [KEY]="'PERSONAL_NETWORKS'"
(updateParent)="updateBusinessNetwork($event)" [holder]="'Search by members, email or organization'"
(updateMembers)="updateBusinessNetworkMembers($event)" [onSearch]="onSearch"
[onFilter]="onFilter" [this]="this" [onScroll]="onScroll"></app-manage-template>
